import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import { MeetingService } from "../../services/MeetingService";
import { toast } from "react-toastify";

const ViewMeetingDetails = ({ meetingId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [meetingDetails, setMeetingDetails] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      await MeetingService.editMeeting(meetingId, editForm);
      toast.success("Meeting updated successfully.");
      setIsEditing(false);
      fetchMeetingDetails(); // Refresh after save
    } catch (error) {
      toast.error(error?.message || "Failed to update meeting");
    }
  };

  const fetchMeetingDetails = async () => {
    try {
      const data = await MeetingService.getMeetingById(meetingId);
      setMeetingDetails(data.data);
    } catch (error) {
      toast.error(error?.message || "Failed to fetch meeting details");
    }
  };

  useEffect(() => {
    fetchMeetingDetails();
  }, []);

  return (
    <div className="space-y-5">
      {/* Details Grid */}
      <div className="grid grid-cols-2 gap-6 text-sm text-gray-700">
        <div>
          <label className="block text-gray-500 font-medium">Title</label>
          {isEditing ? (
            <input
              type="text"
              name="title"
              value={editForm.title}
              onChange={handleChange}
              className="mt-1 border border-gray-300 p-2 w-full rounded-lg focus:outline-none  shadow-sm"
            />
          ) : (
            <p className="mt-1 font-semibold">{meetingDetails?.title}</p>
          )}
        </div>

        <div>
          <label className="block text-gray-500 font-medium">Date</label>
          {isEditing ? (
            <input
              type="date"
              name="date"
              value={editForm.date}
              onChange={handleChange}
              className="mt-1 border border-gray-300 p-2 w-full rounded-lg focus:outline-none  shadow-sm"
            />
          ) : (
            <p className="mt-1 font-semibold">{meetingDetails?.date?.slice(0, 10)}</p>
          )}
        </div>

        <div>
          <label className="block text-gray-500 font-medium">Time</label>
          {isEditing ? (
            <input
              type="time"
              name="time"
              value={editForm.time}
              onChange={handleChange}
              className="mt-1 border border-gray-300 p-2 w-full rounded-lg focus:outline-none  shadow-sm"
            />
          ) : (
            <p className="mt-1 font-semibold">
              {new Date(`1970-01-01T${meetingDetails?.time}`).toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })}
            </p>
          )}
        </div>

        <div>
          <label className="block text-gray-500 font-medium">Agenda</label>
          {isEditing ? (
            <input
              type="text"
              name="agenda"
              value={editForm.agenda}
              onChange={handleChange}
              className="mt-1 border border-gray-300 p-2 w-full rounded-lg focus:outline-none  shadow-sm"
            />
          ) : (
            <p className="mt-1 font-semibold">{meetingDetails?.agenda}</p>
          )}
        </div>

        <div className="col-span-2">
          <label className="block text-gray-500 font-medium">Meeting Link</label>
          {isEditing ? (
            <input
              type="text"
              name="meetingLink"
              value={editForm.meetingLink}
              onChange={handleChange}
              className="mt-1 border border-gray-300 p-2 w-full rounded-lg focus:outline-none  shadow-sm"
            />
          ) : (
            <a
              href={meetingDetails?.meetingLink}
              target="_blank"
              rel="noreferrer"
              className="mt-1 inline-block text-blue-600 underline break-words font-medium"
            >
              {meetingDetails?.meetingLink}
            </a>
          )}
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-3 border-t pt-4">
        {!isEditing ? (
          <Button
            onClick={() => {
              setEditForm({
                title: meetingDetails?.title || "",
                date: meetingDetails?.date?.slice(0, 10) || "",
                time: meetingDetails?.time || "",
                agenda: meetingDetails?.agenda || "",
                meetingLink: meetingDetails?.meetingLink || "",
              });
              setIsEditing(true);
            }}
            variant="contained"
            className="btn-gradient !capitalize !w-[100px] !font-semibold !text-white"
          >
            Edit
          </Button>
        ) : (
          <>
            <Button
              onClick={() => {
                setIsEditing(false);
                setEditForm({});
              }}
              variant="outlined"
              className="!text-gray-700 !bg-white !capitalize !w-[100px] !font-medium !border !border-gray-300"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              className="btn-gradient !capitalize !w-[100px] !font-semibold !text-white"
            >
              Save
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ViewMeetingDetails;
